<template>
    <el-dialog :title="title" :visible.sync="selfVisible" width="600px">
        <el-form
            :model="params"
            :rules="rules"
            size="small"
            ref="form"
            label-width="120px"
            v-if="formVisible"
        >
            <el-form-item label="区服方式" prop="type">
                <el-radio-group v-model="params.type" @change="typeChange">
                    <el-radio label="single">按单服筛选</el-radio>
                    <el-radio label="range">选择区服段</el-radio>
                    <el-radio label="all">全部</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item
                label="选择区服"
                prop="ids"
                v-show="params.type !== 'range'"
            >
                <div class="range-select w400">
                    <el-select
                        v-model="params.ids"
                        size="small"
                        filterable
                        clearable
                        multiple
                        :disabled="params.type === 'all'"
                        placeholder="请选择"
                        class="w400"
                    >
                        <el-option
                            v-for="item in filterServers"
                            :key="item.server_auto_id"
                            :label="
                                (item.display_server_name || item.server_name) +
                                    '（' +
                                    item.server_id +
                                    '）'
                            "
                            :value="item.server_auto_id"
                        >
                        </el-option>
                    </el-select>
                </div>
            </el-form-item>
            <el-form-item
                label="选择区服"
                prop="range"
                v-show="params.type === 'range'"
            >
                <div class="range-select w400">
                    <el-select
                        v-model="params.begin"
                        size="small"
                        filterable
                        clearable
                        :disabled="params.type === 'all'"
                        placeholder="请选择"
                    >
                        <el-option
                            v-for="item in beginServers"
                            :key="item.server_auto_id"
                            :label="
                                (item.display_server_name || item.server_name) +
                                    '（' +
                                    item.server_id +
                                    '）'
                            "
                            :value="item.server_auto_id"
                        >
                        </el-option>
                    </el-select>
                    <span>至</span>
                    <el-select
                        v-model="params.end"
                        size="small"
                        filterable
                        clearable
                        :disabled="params.type === 'all'"
                        placeholder="请选择"
                    >
                        <el-option
                            v-for="item in endServers"
                            :key="item.server_auto_id"
                            :label="
                                (item.display_server_name || item.server_name) +
                                    '（' +
                                    item.server_id +
                                    '）'
                            "
                            :value="item.server_auto_id"
                        >
                        </el-option>
                    </el-select>
                </div>
            </el-form-item>
            <el-form-item
                label="维护时间"
                prop="time"
                v-if="type === 'maintain'"
            >
                <el-date-picker
                    v-model="params.time"
                    type="datetimerange"
                    align="right"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :default-time="['12:00:00', '22:00:00']"
                >
                </el-date-picker>
            </el-form-item>
            <el-form-item
                label="开服时间"
                prop="time"
                v-else-if="type === 'open'"
            >
                <el-date-picker
                    class="w400"
                    v-model="params.time"
                    type="datetime"
                    align="right"
                    placeholder="选择开服时间"
                    default-time="12:00:00"
                >
                </el-date-picker>
            </el-form-item>
            <el-form-item
                label="数据来源"
                prop="data_source"
                v-if="type === 'config'"
            >
                <el-radio-group v-model="params.data_source" @change="dsChange">
                    <el-radio :label="0">接口同步</el-radio>
                    <el-radio :label="1">人工编辑</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item
                label="区服类型"
                prop="server_type"
                v-if="type === 'config'"
            >
                <el-radio-group
                    v-model="params.server_type"
                    :disabled="params.data_source === 0"
                >
                    <el-radio :label="1">正式</el-radio>
                    <el-radio :label="2">测试</el-radio>
                    <el-radio :label="3">审核</el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item
                class="dialog-tips-box"
                label="提示"
                v-if="type === 'maintain'"
            >
                <div>北京时区</div>
            </el-form-item>
            <div
                class="dialog-tips-box"
                style="color:red;padding-left:52px;width:460px;"
                v-else-if="type === 'open'"
            >
                开服时间生效条件：<br />
                1. 数据来源为人工编辑时，配置的开服时间会生效<br />
                2.
                数据来源为接口同步时，但CP同步的数据中没有开服时间，会以配置时间为准
            </div>
            <div
                class="dialog-tips-box"
                style="color:red;padding-left:52px;width:460px;"
                v-else-if="type === 'config'"
            >
                注：数据来源为接口同步时，会从CP同步区服类型、合服到、开服时间等字段<br />
                数据来源为人工编辑时，区服类型、合服到、开服时间以人工编辑的为准
            </div>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button size="mini" @click="selfVisible = false"
                >取 消</el-button
            >
            <el-button size="mini" type="primary" @click="submit"
                >提 交</el-button
            >
        </div>
    </el-dialog>
</template>
<script>
import moment from "moment";
export default {
    name: "ServerDialog",
    data() {
        return {
            selfVisible: false,
            formVisible: false,
            params: {
                type: "single",
                begin: "",
                end: "",
                range: [],
                ids: [],
                time: "",
                data_source: "",
                server_type: ""
            }
        };
    },
    props: {
        // maintain open config
        type: {
            type: String,
            default: "maintain"
        },
        servers: {
            type: Array,
            required: true
        },
        srcServers: {
            type: Array,
            required: true
        },
        selectedIds: {
            type: Array
        },
        title: String,
        visible: {
            type: Boolean
        }
    },
    watch: {
        visible: {
            handler(val) {
                this.selfVisible = val;
            },
            immediate: true
        },
        selfVisible(val) {
            if (!val) {
                this.$emit("update:visible", false);
                setTimeout(() => {
                    this.formVisible = false;
                }, 300);
            } else {
                this.formVisible = true;
            }
        },
        formVisible(val) {
            // reset params after dialog opened
            if (val) {
                this.params = {
                    type: "single",
                    begin: "",
                    end: "",
                    range: [],
                    ids: this.selectedIds,
                    time:
                        this.type === "maintain"
                            ? [
                                  moment().utcOffset(8).toDate(),
                                  moment().utcOffset(8)
                                      .add(1, "M")
                                      .toDate()
                              ]
                            : moment().utcOffset(8).toDate(),
                    data_source: "",
                    server_type: ""
                };
            }
        },
        selectedIds: {
            handler(val) {
                this.params.ids = val;
            },
            immediate: true
        },
        "params.type"(val) {
            if (val === "all") {
                this.params.ids = [];
            }
        },
        "params.begin"() {
            this.setParamsRange();
        },
        "params.end"() {
            this.setParamsRange();
        }
    },
    computed: {
        timeLabelText() {
            return this.type === "open"
                ? "开服时间"
                : this.type === "maintain"
                ? "维护时间"
                : "";
        },
        rules() {
            return {
                type: [{ required: true, message: "" }],
                time: [
                    { required: true, message: "请选择" + this.timeLabelText }
                ],
                range: [
                    {
                        required: this.params.type === "range",
                        message: "请选择服务器"
                    }
                ],
                ids: [
                    {
                        required: this.params.type === "single",
                        message: "请选择服务器"
                    }
                ],
                data_source: [
                    {
                        required: this.type === "config",
                        message: "请选择数据来源"
                    }
                ],
                server_type: [
                    {
                        required:
                            this.type === "config" &&
                            this.params.data_source === 1,
                        message: "请选择区服类型"
                    }
                ]
            };
        },
        filterServers() {
            if (this.type === "config") {
                return this.srcServers;
            }
            return this.servers;
        },
        serverIds() {
            return this.filterServers.map(v => v.server_auto_id);
        },
        beginServers() {
            if (this.params.end) {
                let idx = this.serverIds.indexOf(this.params.end);
                return this.filterServers.slice(0, idx + 1);
            }
            return this.filterServers;
        },
        endServers() {
            if (this.params.begin) {
                let idx = this.serverIds.indexOf(this.params.begin);
                return this.filterServers.slice(idx);
            }
            return this.filterServers;
        },
        rangeIds() {
            if (!this.params.range.length) {
                return [];
            }
            let begin = this.serverIds.indexOf(this.params.begin),
                end = this.serverIds.indexOf(this.params.end);
            return this.serverIds.slice(begin, end + 1);
        },
        finalIds() {
            let tmp;
            switch (this.params.type) {
                case "single":
                    tmp = this.params.ids;
                    break;
                case "range":
                    tmp = this.rangeIds;
                    break;
                case "all":
                    tmp = this.serverIds;
                    break;
            }
            return tmp;
        }
    },
    methods: {
        typeChange() {
            this.$refs.form.clearValidate([
                "ids",
                "range",
                "server_type",
                "data_source"
            ]);
        },
        dsChange() {
            if (this.params.data_source === 0) {
                this.params.server_type = "";
            }
            this.$refs.form.clearValidate(["ids", "range", "server_type"]);
        },
        setParamsRange() {
            if (!this.params.begin || !this.params.end) {
                this.params.range = [];
            } else {
                this.params.range = [this.params.begin, this.params.end];
            }
            setTimeout(() => {
                this.$refs.form.clearValidate(["range"]);
            });
        },
        getSubmitParams() {
            let tmp = {};
            tmp.server_auto_id_list = this.finalIds.join(",");

            let time = Array.isArray(this.params.time)
                ? this.params.time
                : [this.params.time];
            tmp.time = time.map(v => {
                return moment(v).utcOffset(8).format("X");
            });

            if (this.type === "config") {
                tmp.data_source = this.params.data_source;
                tmp.server_type = this.params.server_type;
                tmp.server_type = tmp.data_source === 0 ? 3 : tmp.server_type;
                delete tmp.time;
            }
            return tmp;
        },
        submit() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    let params = this.getSubmitParams();
                    this.$emit("submit", params);
                }
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.w400 {
    width: 400px;
}
.range-select {
    display: flex;
    justify-content: space-between;
    > span {
        margin: 0 5px;
    }
}
</style>



// WEBPACK FOOTER //
// website/subComponents/ServerDialog.vue